import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import { useNavigation } from "../../utils/navigation";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderInput from "./components/HeaderInput";
import CategoryList from "./components/CategoryList";
import HeaderSlider from "./components/HeaderSlider";
import HamburgerMenuLeft from "./mobile/HamburgerMenuLeft";
import CartMenu from "./mobile/CartMenu";
import { AuthUserContext } from "../../context/AuthUserContext";
import { useTranslation } from "react-i18next";
import Language from "../../components/account/Language";
import DesktopHeader from "./components/DesktopHeader";

const Container = styled.div`
  position: relative;
`;

const MainHeaderWrapper = styled.div`
  width: 100%;

  max-width: 100vw;
  box-shadow: var(--shadow-default);
  z-index: var(--zindex-top);
  position: fixed;
  top: ${(props) => (props.$isScrolled ? "0" : "initial")};
  left: 0;
  //
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--bg-200);

  box-shadow: ${(props) =>
    props.$isScrolled ? "var(--shadow-medium)" : "none"};

  transition: ${(props) =>
    props.$isScrolled ? "all 0.2s ease-out" : "all 0.1s ease-in"};

  @media (min-width: 768px) {
    //min-height: var(--navbar-height-desktop);
  }
  @media (min-width: 768px) and (max-width: 1040px) {
  }
`;
const GridContainer = styled.header`
  height: var(--navbar-height);
  width: 100%;
  max-width: 90%;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (min-width: 768px) {
    height: var(--navbar-height-desktop);
    grid-template-columns: 1fr 1fr 1fr;
    max-width: var(--max-width-container);
    padding: 0;
  }
  @media (min-width: 768px) and (max-width: 1040px) {
    max-width: 90%;
  }
  gap: 4px;
`;
const GridItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-lg);

  &:nth-child(1) {
    justify-content: flex-start;
  }
  &:nth-child(2) {
    justify-content: flex-end;
    margin-right: 12px;
  }

  &:nth-child(3) {
    justify-content: flex-end;
  }
  @media (min-width: 768px) {
    &:nth-child(2) {
      justify-content: center;
    }
  }
`;
const GridItemRight = styled(GridItem)`
  //justify-content: flex-end;
`;

const Logo = styled.div`
  color: var(--text-200);
  font-size: var(--font-size-xlarge);
  font-style: normal;
  font-weight: 500;
  letter-spacing: -0.438px;
  display: flex;
  gap: var(--spacing-xs);

  align-items: center;
  cursor: pointer;
`;
const CartContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  @media (min-width: 768px) {
    height: 40px;
    min-width: 40px;
    min-height: 40px;
  }
  svg {
    fill: var(--text-200);
    transition: fill 0.3s ease; /* Dodaj tranziciju za glatki prelaz boje */
  }

  &:hover svg {
    fill: var(--primary-100); /* Boja pri hoveru */
  }
  &:hover h4 {
    color: var(--primary-100);
  }
`;
const CartText = styled.h4`
  display: none;
  cursor: pointer;
  @media (min-width: 768px) {
    display: inline-block;
  }

  font-weight: 200;
`;
const IconDivDesktop = styled.div`
  display: none;

  @media (min-width: 1040px) {
    display: block;
  }
`;
const IconDivNoDesktop = styled.div`
  display: block;
  @media (min-width: 1040px) {
    display: none;
  }
`;

const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 200px;
  background-color: var(--bg-100);

  @media (min-width: 768px) {
    position: absolute;
    width: auto;

    top: calc(100% - var(--navbar-mini));
    background-color: var(--bg-200);
  }
`;
const DropdownWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  flex-direction: column;

  cursor: pointer;
  margin: 8px 0;
  font-size: var(--font-size-base);
  gap: 12px;
`;
const DropdownText = styled.div`
  padding: 8px 12px;
  width: 100%;
  &:hover {
    color: var(--primary-200); // Boja teksta kada je labela hoverovana
  }
`;

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoHovered, setLogoHovered] = useState(false);
  const { authTokens } = useContext(AuthUserContext);
  const {
    goToHome,
    goToLogin,
    goToShop,
    goToAccount,
    goToBestSeller,
    goToRegister,
  } = useNavigation();
  const navigate = useNavigate();
  const [showUserDropbox, setShowUserDropbox] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0); // Ažurira state ako korisnik skroluje nadole
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Očistite event listener kad se komponenta demontira
    };
  }, []);

  //CART
  const cartItems = useSelector((state) => state.cart.itemsList);
  let totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const favorite = 2;
  return (
    <Container>
      <MainHeaderWrapper $isScrolled={isScrolled}>
        <HeaderSlider />
        <GridContainer>
          <GridItem>
            <IconDivNoDesktop>
              <HamburgerMenuLeft />
            </IconDivNoDesktop>
            <Logo onClick={() => navigate(goToHome())}>
              <svg
                width="50"
                height="50"
                viewBox="0 0 298 298"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onMouseEnter={() => setLogoHovered(true)}
                onMouseLeave={() => setLogoHovered(false)}
              >
                <path
                  d="M148.707 0C66.7245 0 0 66.7245 0 148.707C0 230.689 66.7245 297.414 148.707 297.414C230.689 297.414 297.414 230.689 297.414 148.707C297.414 66.7245 230.689 0 148.707 0ZM294.707 148.707C294.707 188.275 278.843 224.204 253.18 250.567L244.688 242.074C268.158 217.904 282.669 184.962 282.669 148.707C282.669 112.452 267.878 78.8562 243.988 54.6394L252.48 46.1472C278.563 72.557 294.661 108.766 294.661 148.707H294.707ZM17.3576 148.707C17.3576 76.2899 76.2432 17.4043 148.66 17.4043C221.077 17.4043 279.963 76.2899 279.963 148.707C279.963 221.124 221.077 280.009 148.66 280.009C76.2432 280.009 17.3576 221.124 17.3576 148.707ZM250.52 44.2808L242.028 52.7731C217.858 29.2562 184.915 14.7447 148.614 14.7447C112.312 14.7447 79.416 29.2562 55.2458 52.7731L46.7536 44.2808C73.0701 18.6176 108.999 2.75295 148.567 2.75295C188.135 2.75295 224.11 18.6175 250.427 44.3275L250.52 44.2808ZM44.7939 46.1939L53.2862 54.6862C29.3494 78.9029 14.558 112.172 14.558 148.8C14.558 185.429 29.0693 218.044 52.5862 242.214L44.1406 250.707C18.4307 224.39 2.56627 188.415 2.56627 148.847C2.56627 109.279 18.7107 72.6504 44.7939 46.2872V46.1939ZM46.0539 252.667L54.5461 244.174C78.7629 268.064 111.985 282.856 148.614 282.856C185.242 282.856 218.511 268.064 242.728 244.128L251.22 252.62C224.857 278.703 188.602 294.848 148.66 294.848C108.719 294.848 72.5102 278.703 46.147 252.667"
                  fill="var(--text-200)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M207.722 57.7351C202.622 66.9627 200.922 78.8759 205.416 87.3302C214.54 104.491 230.158 114.314 239.894 131.851C273.15 191.781 209.011 201.72 174.784 209.915C155.428 214.537 143.812 230.506 158.492 258.688C214.436 253.98 258.39 207.07 258.39 149.903C258.39 111.144 238.177 77.1018 207.722 57.7266"
                  fill={
                    !logoHovered ? "var(--primary-200)" : "var(--primary-100)"
                  }
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M191.927 105.506C177.373 95.2564 162.525 82.7355 160.972 63.8935C160.307 55.8558 164.875 48.4915 171.632 43.0459C157.459 40.0907 142.84 39.9776 128.623 42.713C114.406 45.4483 100.873 50.9779 88.8086 58.9812C96.9207 91.2874 127.561 94.6763 155.629 103.143C195.722 115.235 214.322 153.656 158.871 159.818C81.4401 168.423 72.2954 187.545 127.861 256.987C133.447 258.095 139.112 258.763 144.803 258.984C114.222 212.039 131.18 198.9 188.95 180.965C245.166 163.485 224.646 128.565 191.925 105.51"
                  fill="var(--accent-100)"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M123.936 118.509C100.162 114.213 67.312 112.348 58.2119 97.5595C57.3549 96.166 56.5939 94.7157 55.9342 93.2188C45.5264 110.296 40.0342 129.915 40.0626 149.915C40.0626 197.952 71.1131 238.761 114.236 253.341C95.0693 233.567 63.4812 210.21 71.1047 172.043C76.204 146.547 105.038 150.269 127.675 148.404C160.298 145.722 156.82 124.463 123.927 118.509"
                  fill={
                    !logoHovered ? "var(--primary-200)" : "var(--primary-100)"
                  }
                />
              </svg>
              SnusCo
            </Logo>
          </GridItem>

          <GridItem>
            <HeaderInput />
          </GridItem>

          <GridItemRight>
            <CartMenu />

            <CartContainer
              onClick={() => {
                if (showUserDropbox) {
                  setShowUserDropbox(false);
                  return;
                }
                if (authTokens) {
                  navigate(goToAccount());
                } else {
                  setShowUserDropbox(true);
                }
              }}
            >
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                width="22px"
                height="22px"
                viewBox="0 0 311.541 311.541"
                xmlSpace="preserve"
              >
                <g>
                  <g>
                    <path
                      d="M155.771,26.331C69.74,26.331,0,96.071,0,182.102c0,37.488,13.25,71.883,35.314,98.761
			c3.404-27.256,30.627-50.308,68.8-61.225c13.946,12.994,31.96,20.878,51.656,20.878c19.233,0,36.894-7.487,50.698-19.936
			c38.503,11.871,65.141,36.27,66.017,64.63c24.284-27.472,39.056-63.555,39.056-103.108
			C311.541,96.071,241.801,26.331,155.771,26.331z M155.771,222.069c-9.944,0-19.314-2.732-27.634-7.464
			c-20.05-11.409-33.855-34.756-33.855-61.711c0-38.143,27.583-69.176,61.489-69.176c33.909,0,61.489,31.033,61.489,69.176
			c0,27.369-14.237,51.004-34.786,62.215C174.379,219.523,165.346,222.069,155.771,222.069z"
                    />
                  </g>
                </g>
              </svg>
              <CartText>
                {authTokens ? t("HEADER.PROFILE") : t("HEADER.SIGN_UP")}
              </CartText>
            </CartContainer>
            {showUserDropbox && (
              <DropdownContainer>
                <DropdownWrapper>
                  <DropdownText
                    onClick={() => {
                      navigate(goToLogin());
                    }}
                  >
                    {t("HEADER.SIGN_IN")}
                  </DropdownText>
                  <DropdownText
                    onClick={() => {
                      navigate(goToRegister());
                    }}
                  >
                    {t("HEADER.CREATE_ACCOUNT")}
                  </DropdownText>
                </DropdownWrapper>
              </DropdownContainer>
            )}
            <IconDivDesktop>
              <Language />
            </IconDivDesktop>
          </GridItemRight>
        </GridContainer>
        <DesktopHeader />
      </MainHeaderWrapper>
      <div />
    </Container>
  );
};

export default Header;
